import { useEffect, useState } from 'react';

const useViewportMenuMaxHeight = (
  wrapperRef,
  isOpen,
  { bottomOffset = 0, viewportMargin = 0, minMenuHeight = 0 } = {}
) => {
  const [maxHeight, setMaxHeight] = useState(null);

  useEffect(() => {
    if (!isOpen || typeof window === 'undefined') {
      setMaxHeight(null);
      return undefined;
    }

    const viewport = window.visualViewport;

    const recompute = () => {
      const wrapper = wrapperRef.current;
      if (!wrapper) return;
      const menuTop = wrapper.getBoundingClientRect().bottom;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const available = viewportBottom - menuTop - bottomOffset - viewportMargin;
      setMaxHeight(available > 0 ? Math.max(Math.round(available), minMenuHeight) : null);
    };

    recompute();
    window.addEventListener('resize', recompute);
    window.addEventListener('scroll', recompute, true);
    if (viewport) {
      viewport.addEventListener('resize', recompute);
      viewport.addEventListener('scroll', recompute);
    }
    return () => {
      window.removeEventListener('resize', recompute);
      window.removeEventListener('scroll', recompute, true);
      if (viewport) {
        viewport.removeEventListener('resize', recompute);
        viewport.removeEventListener('scroll', recompute);
      }
    };
  }, [wrapperRef, isOpen, bottomOffset, viewportMargin, minMenuHeight]);

  return maxHeight;
};

export default useViewportMenuMaxHeight;
